export default {
    bindings: {
        'availability': '=',
        'loading': '<',
        'basket': '<',
        'eventType': '<',
        'getQuantity': '&',
        'staff': '=',
    },
    controller: 'availabilitySliderController',
    template: require('../views/availability.slider.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/availability.slider.component.js